import embarkWeb3 from '..';

module.exports = embarkWeb3;
